import { render, staticRenderFns } from "./ReviewOld.vue?vue&type=template&id=1fd43dc2&"
import script from "./ReviewOld.vue?vue&type=script&lang=js&"
export * from "./ReviewOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports